import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full rounded-xl border border-border bg-surface px-3 text-[15px] text-ink placeholder:text-muted',
        'focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15 disabled:opacity-60 aria-[invalid=true]:border-danger',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'min-h-20 w-full rounded-xl border border-border bg-surface px-3 py-2 text-[15px] text-ink placeholder:text-muted',
        'focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
